import { render, staticRenderFns } from "./DayHeader.vue?vue&type=template&id=ce06fbbc&"
import script from "./DayHeader.vue?vue&type=script&lang=js&"
export * from "./DayHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports